export enum SessionStorageKeys {
  type = 'type',
}
